import React, { useState, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import GenzProfileDetails from './CardEditParts/GenzProfileDetails';
import Previewcard from './PreviewCard';
import ProfileDetails from './CardEditParts/ProfileDetails';
import CardDesigner from './CardEditParts/CardDesignerPaid'; // ./CardEditParts/CardDesigner for Free version 
import Qrcode from './CardEditParts/Qrcode';
import Contactdetails from './CardEditParts/Contactdetails';
import AttachDoc from './CardEditParts/AttachDoc';
import Configuration from './CardEditParts/Configuration';
import SocialLinks from './CardEditParts/SocialLinks';
import ProfessionalDetails from './CardEditParts/ProfessDetails';
import AcademyDetails from './CardEditParts/AcademyDetails';
import { useCardDetailContext } from '../../CardDetailContext';
import useAvailableHeight from '../../Custom/UseAvailableHeight';
import { useQuantityContext } from '../../QuantityContext';

const CardEditTemplate = ({ isSidebarOpen }) => {
    const navigate = useNavigate();
    const isInitialMount = useRef(true);
    const { cardDetails } = useCardDetailContext();
    const { isNavigationBlocked, setisNavigationBlocked, openSnackbar, handleInfo } = useQuantityContext();

    const [availableHeight1, Column2Ref] = useAvailableHeight(158);
    const [availableHeight2, Column3Ref] = useAvailableHeight(158);

    // Initialize state based on cardDetails
    const initialComponent = (cardDetails?.CardType === 'GenZ' || cardDetails?.CardType === 'Customize_GenZ') ? 'Profile Details2' : 'Profile Details';
    const [selectedComponent, setSelectedComponent] = useState(initialComponent);
    const [activeItem, setActiveItem] = useState(initialComponent);

    const [contactItemsOrder, setContactItemsOrder] = useState([
        'call', 'text', 'email', 'whatsapp' // Default order
    ]);

    const handleContactItemsOrderChange = (newOrder) => {
        setContactItemsOrder(newOrder);
    };

    const handleItemClick = async (componentName) => {
        if (isNavigationBlocked) {
            //   if (!window.confirm('You have unsaved changes. Do you really want to leave?')) {
            handleInfo("You have unsaved changes! Please save and proceed.")
            //   return;
            //   }
        }
        setisNavigationBlocked(false);
        setActiveItem(componentName);
        setSelectedComponent(componentName);
    };

    const handleSuccess = (message = '') => {
        let successManage;
        successManage = message ? message : 'Saved Successfully!'
        openSnackbar(successManage, 'success', 3000)
    }

    const handleFailure = (message = '') => {
        let failureMessage;
        failureMessage = message ? message : 'Failed to Save'
        openSnackbar(failureMessage, 'error', 3000)
    }

    const componentMap = useMemo(() => ({
        'Profile Details': <ProfileDetails handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Profile Details2': <GenzProfileDetails handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Professional Details': <ProfessionalDetails handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Academy Details': <AcademyDetails handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Card Designer': <CardDesigner handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'QR Code': <Qrcode handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Contact Details': (
            <Contactdetails
                contactItemsOrder={contactItemsOrder}
                onContactItemsOrderChange={handleContactItemsOrderChange}
                handleSuccess={handleSuccess}
                handleFailure={handleFailure}
            />
        ),
        'Attach Documents': <AttachDoc handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Configuration': <Configuration handleSuccess={handleSuccess} handleFailure={handleFailure} />,
        'Social Links': <SocialLinks handleSuccess={handleSuccess} handleFailure={handleFailure} />,
    }), [contactItemsOrder]);

    return (
        <div className='card-edit-page'>
            <div className="card-edit-container d-flex flex-row">
                <div className={`card-edit-column-1 ${isSidebarOpen ? "" : "collapsed"}`}>
                    <Box sx={{ borderRadius: 2, backgroundColor: "#ffffff" }} className='my-4 ms-4 card-side-nav'>
                        <div className="card-edit-list-container">
                            <ul>
                                {(cardDetails?.CardType === "GenZ") || (cardDetails?.CardType === "Customize_GenZ") ? (
                                    <li className={activeItem === 'Profile Details2' ? 'active' : ''} onClick={() => handleItemClick('Profile Details2')}>Profile Details</li>
                                ) : (
                                    <li className={activeItem === 'Profile Details' ? 'active' : ''} onClick={() => handleItemClick('Profile Details')}>Profile Details</li>
                                )}
                                {(cardDetails?.CardType === "Professional" || cardDetails?.CardType === "Customize_Professional") && (
                                    <li className={activeItem === 'Professional Details' ? 'active' : ''} onClick={() => handleItemClick('Professional Details')}>Professional Details</li>
                                )}
                                {(cardDetails?.CardType === "Student" || cardDetails?.CardType === "Customize_Student") && (
                                    <li className={activeItem === 'Academy Details' ? 'active' : ''} onClick={() => handleItemClick('Academy Details')}>Academy Details</li>
                                )}
                                <li className={activeItem === 'Card Designer' ? 'active' : ''} onClick={() => handleItemClick('Card Designer')}>Card Designer</li>
                                <li className={activeItem === 'QR Code' ? 'active' : ''} onClick={() => handleItemClick('QR Code')}>QR Code</li>
                                <li className={activeItem === 'Social Links' ? 'active' : ''} onClick={() => handleItemClick('Social Links')}>Social Links</li>
                                <li className={activeItem === 'Attach Documents' ? 'active' : ''} onClick={() => handleItemClick('Attach Documents')}>Attach Documents</li>
                                <li className={activeItem === 'Contact Details' ? 'active' : ''} onClick={() => handleItemClick('Contact Details')}>Contact Details</li>
                                <li className={activeItem === 'Configuration' ? 'active' : ''} onClick={() => handleItemClick('Configuration')}>Configuration</li>
                            </ul>
                        </div>
                    </Box>
                </div>
                <div className="card-edit-column-2 mx-4">
                    <Box className='my-4 card-info-box' sx={{ backgroundColor: "white", borderRadius: 2, paddingTop: "16px", maxHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none" }} ref={Column2Ref}>
                        {componentMap[selectedComponent]}
                    </Box>
                </div>
                <div className={`card-edit-column-3 ${isSidebarOpen ? "" : "collapsed"}`}>
                    <Box className='my-4 me-4 card-info-box' sx={{ backgroundColor: "white", borderRadius: 2, padding: "16px 5px 5px", maxHeight: `${availableHeight2}px`, overflowY: "auto", scrollbarWidth: "none" }} ref={Column3Ref}>
                        <Previewcard contactItemsOrder={contactItemsOrder} activeItem={activeItem} />
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default CardEditTemplate;
